module.exports = __webpack_public_path__ + "img/32.3.TP.914c3ce1.png";